import StatusDot from './StatusDot'

export default StatusDot
